<template>
  <div
    id="offers"
    :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }"
  >
    <header-o :model="headerData"></header-o>
    <div class="margin-10" style="margin-top: -160px">
      <div v-if="!isEmpty(giftCardData)" style="margin-bottom:75px">
        <div
          class="bg-light bottom-radius-5 padding-10 pos-rel box-shadow"
          :style="{ backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff' }"
          style="min-height: 150px; border-radius: 10px; padding-top: 20px !important;"
        >
          <div class="bottom-border">
            <div
              style="font-size: 16px; font-weight: 500;"
              class="margin-bottom-10"
              :style="{ color: isDarkTheme ? subHeadingTextColor : '#4a4a4a' }"
            >
              {{ giftCardData.name }}
            </div>
            <img class="w30 margin-bottom-5" :src="giftCardData.image_url" />
            <div
              class="margin-bottom-10 text-large"
              :style="{ color: isDarkTheme ? '#848884' : '#9A9A9A' }"
              v-if="giftCardData.currency_label && giftCardData.value"
            >
              Value:
              <!-- <span class="font-bold" :style="{ color: subHeadingTextColor }"
                >₹{{ giftCardData.value }}</span
              > -->
              <span style="font-weight: 500;" :style="{ color: '#323232' }">
                <template v-if="giftCardData.currency_code === 'INR'">
                  ₹ {{ giftCardData.value }}
                </template>

                <template v-else style="font-weight: 500;">
                  {{ giftCardData.value }}
                  {{ giftCardData.currency_code }}
                </template>
              </span>
            </div>
            <div
              :style="{
                color: isDarkTheme ? subHeadingTextColor : '#000000',
                justifyContent:
                  giftCardData.expiry !== '' && giftCardData.expiry !== null
                    ? 'space-between'
                    : 'end'
              }"
              class="align-hor center-ver"
              style="margin-bottom: 20px;"
            >
              <div
                v-if="
                  giftCardData.expiry !== '' && giftCardData.expiry !== null
                "
              >
                <span :style="{ color: isDarkTheme ? '#848884' : '#848884' }"
                  >Validity:</span
                >
                <span style="font-weight: 500;">{{
                  giftCardData.expiry ? giftCardData.expiry : "1 year"
                }}</span>
              </div>
              <div class="align-hor center-ver">
                <div
                  class="margin-right-5"
                  :style="{ color: isDarkTheme ? '#848884' : '#848884' }"
                >
                  Use:
                </div>
                <div
                  class="wrap align-hor center-ver center-hor padding-5 radius-3 pointer"
                  @click="toggleGiftModal(true, giftCardData)"
                  :style="{
                    border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                    backgroundColor: isDarkTheme ? '#ffffff' : '#ffffff',
                    padding: '6px 25px',
                    borderRadius: '20px',
                    fontSize: '12px'
                  }"
                >
                  <img
                    class="smaller-icon pull-left margin-right-5"
                    :src="walletActivecurrencyIcon.icon_url"
                  />
                  {{ giftCardData.currency_req }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="padding-10"
            :style="{ color: isDarkTheme ? subHeadingTextColor : '#000000' }"
          >
            <div class="about text-left margin-bottom-20">
              <div
                class=" margin-bottom-10"
                style="font-weight: 500; color: #757575;"
              >
                About
              </div>
              <!-- <div v-html="giftCardData.description"></div> -->
              <p
                style="font-weight: 500; font-size: 14px;"
                :style="{ color: isDarkTheme ? '#000000' : '#848884' }"
              >
                {{ giftCardData.description }}
              </p>
            </div>
            <div class="terms">
              <div class="align-hor center-ver space-between">
                <div style="font-weight: 500; color: #757575;">
                  Terms & Conditions
                </div>
                <div v-if="!isShowTNC">
                  <img
                    class="w-15 margin-bottom-5 pointer"
                    v-if="!isShowTNC && !isDarkTheme"
                    src="@/assets/arrow-down.svg"
                    @click="toggleTNC(true)"
                  />
                  <img
                    class="w-15 margin-bottom-5 pointer"
                    v-if="!isShowTNC && isDarkTheme"
                    src="@/assets/down1.png"
                    @click="toggleTNC(true)"
                  />
                </div>
                <div v-else>
                  <img
                    v-if="!isDarkTheme"
                    class="w-15 margin-bottom-5 pointer"
                    src="@/assets/arrow-up.svg"
                    @click="toggleTNC(false)"
                  />
                  <img
                    v-if="isDarkTheme"
                    class="w-15 margin-bottom-5 pointer"
                    src="@/assets/upload.png"
                    @click="toggleTNC(false)"
                  />
                </div>
              </div>
              <div v-if="isShowTNC" style="margin-top: 15px;">
                <ol class="text-left" style="padding-left: 0px !important;">
                  <li class="margin-bottom-10" v-if="giftCardData.tnc_link">
                    <a :href="giftCardData.tnc_link">{{
                      giftCardData.tnc_link
                    }}</a>
                  </li>
                  <!-- <li
                    class="margin-bottom-10 word-break"
                    v-else
                    v-html="giftCardData.tnc_content"
                  ></li> -->
                  <p
                    style="font-weight: 500; font-size: 14px;"
                    :style="{ color: isDarkTheme ? '#000000' : '#848884' }"
                  >
                    {{ giftCardData.tnc_content }}
                  </p>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <gift-popup :model="giftCardData" v-if="isGiftPopup"></gift-popup>
      </div>

      <div
        class="bg-light bottom-radius-5 padding-10 pos-rel box-shadow"
        v-if="isEmpty(giftCardData)"
      >
        <div class="bg-light radius-5 padding-10 pos-rel">
          <div class="wrapper align-ver center-ver margin-bottom-15">
            <div class="comment animate bg-light-grey w40"></div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-15">
            <div
              class="comment animate bg-light-grey w30"
              v-for="$i in 6"
            ></div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-15">
            <div class="comment animate bg-light-grey w30"></div>
          </div>
          <div
            class="align-hor center-ver space-between bottom-border padding-bottom-10"
          >
            <div class="w40">
              <div class="wrapper align-hor center-hor">
                <div
                  class="comment animate bg-light-grey margin-bottom-5 w30 margin-right-5"
                ></div>
                <div
                  class="comment animate bg-light-grey margin-bottom-5 w70"
                ></div>
              </div>
            </div>
            <div class="w30">
              <div class="wrapper align-hor end-ver">
                <div
                  class="comment animate bg-light-grey margin-bottom-5 w50"
                ></div>
                <div class="wrapper align-ver center-hor end-ver">
                  <div class="comment animate bg-light-grey w85"></div>
                  <div class="comment animate bg-light-grey w85"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="padding-horizontal-20">
            <div class="wrapper margin-bottom-20">
              <div
                class="comment animate bg-light-grey margin-bottom-5 w30 margin-right-5"
              ></div>
            </div>
            <div class="wrapper">
              <div
                class="comment animate bg-light-grey margin-bottom-10 w70"
              ></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w85"
              ></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w80"
              ></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w50"
              ></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w70"
              ></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w80"
              ></div>
              <div
                class="comment animate bg-light-grey margin-bottom-10 w50"
              ></div>
            </div>
          </div>
          <div class="wrapper align-hor space-between">
            <div class="comment animate bg-light-grey w50 margin-right-5"></div>
            <div class="comment animate bg-light-grey w10"></div>
          </div>
        </div>
      </div>
    </div>

    <footer
      v-if="!isGiftPopup"
      class="footer"
      style="display: flex;
    flex-direction: row; justify-content: center;
    height: 30px; border-top: 1px solid #EFEFEF;"
      :style="{ backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff' }"
    >
      <!-- 
<div v-if="notEnoughBalance" style=" position: absolute; left: 20%; bottom: 20%;"
class="pos-fixed toast text-light padding-10 radius-30"
>
  <p style="margin: 0px; font-size: 10px;">Not enough balance!</p>
</div> -->

      <div
        class="padding-vertical-5"
        :style="{ background: isDarkTheme ? buttonBGColor : bgTheme }"
        style="margin-right: auto;
                  margin-left: auto;
                  width: 90%;
                  align-items: center;
                  display:flex;
                   border-radius: 4px;
                  justify-content: center; height: 40px;"
        @click="toggleGiftModal(true, giftCardData)"
      >
        <!--        <router-link :to="{name: 'quiz_questions', params: {id: game_data.id}}">
                  <a class="btn text-uppercase" style="color: #fff; padding: 8px 0; background: var(&#45;&#45;bg-color); width: 150px; height: 20px; border-radius: 50px;" role="button">Play Quiz Now</a>
                </router-link>-->
        <span
          class="btn"
          style="color: #ffffff; padding: 8px 0;
            width: 150px; height: 20px; border-radius: 50px;"
          role="button"
          :style="{ color: isDarkTheme ? headingTextColor : '#ffffff' }"
          >Redeem</span
        >
      </div>
    </footer>
    <pan-dialog
      :show="showPanDialog"
      @close="showPanDialog = false"
      @success="onPanValidated()"
    />
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import Milestone from "@/components/milestone";
import GiftCardPopup from "@/components/gift-card-popup";
import PanDialog from "@/components/pan-dialog.vue";
import { isDate } from "moment/moment";
export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    milestone: Milestone,
    "gift-popup": GiftCardPopup,
    "pan-dialog": PanDialog
  },
  data() {
    return {
      headerData: {
        onlyHeader: true,
        balance: true
      },
      giftCardData: {},
      showTNC: false,
      toggle: false,
      notEnoughBalance: false,
      showPanDialog: false,
      pendingGiftCard: null
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    subHeadingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.subHeadingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.subHeadingTextColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    },
    isShowTNC: function() {
      return this.showTNC;
    }
  },
  methods: {
    buyGiftCard(gc) {
      var curr_bal = parseInt(this.userHeaderBalance.balance.split(" ")[0]);
      console.log("GC -", gc);
      console.log("Current Balance :", curr_bal);

      if (curr_bal < gc.currency_req) {
        console.log("Not enough balance..");
        this.notEnoughBalance = true;

        // auto-hide message after 2 seconds
        setTimeout(() => {
          this.notEnoughBalance = false;
        }, 2000);

        return false;
      }

      var name = this.receiverName;
      var email = this.receiverEmail;
      var sku = gc.sku;
      var price = gc.value;
      if (!name) {
        this.toastPopup(true, "Please enter the receiver name");
        return false;
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        this.toastPopup(true, "Please enter valid  email");
        return false;
      }

      if (!email) {
        this.toastPopup(true, "Please enter the receiver email");
        return false;
      }

      if (!sku) {
        this.toastPopup(true, "Invalid Gift card!");
        return false;
      }

      if (!price) {
        this.toastPopup(true, "Invalid amount!");
        return false;
      }

      this.validateEmail(email);

      var data = {
        name: name,
        email: email,
        sku: sku,
        price: price
      };

      var url = this.$store.getters.flyyDomain + "/buy_gift_cards";
      var headers = this.$store.getters.headers;

      var options = {
        method: "post",
        url: url,
        headers: headers,
        data: data
      };

      axios(options)
        .then(resp => {
          if (resp.status == 200) {
            if (resp.data.success) {
              this.$store.state.giftCardBuy = false;
              this.refNum = resp.data.ref_num;
              this.toastPopup(true, resp.data.message);
            } else if (resp.data.pan_required) {
              this.pendingGiftCard = gc;
              this.showPanDialog = true;
            } else {
              this.toggleGiftModal(false, gc);
              this.toastPopup(true, resp.data.message);
            }
          } else {
            this.toggleGiftModal(false, gc);
            this.toastPopup(true, resp.data.message);
          }
        })
        .catch(err => {
          this.toggleGiftModal(false, gc);
          console.log("Redemption error!");
        });
    },
    onPanValidated() {
      var gc = this.pendingGiftCard;
      this.showPanDialog = false;
      this.pendingGiftCard = null;
      if (gc) {
        this.buyGiftCard(gc);
      }
    },
    toggleTNC(state) {
      this.showTNC = state;
      this.toggle = !state;
    },
    getGiftCardDetails(id) {
      var url = this.$store.getters.flyyDomain + "/get_gift_card/" + id;
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers
        })
        .then(resp => {
          if (resp.data.success) {
            var gift_card = resp.data.gift_card;
            this.giftCardData = gift_card;
          }
        });
    }
  },
  created() {
    this.$store.state.showHeader = false;
    this.$store.state.headTitle = "Card Details";
    // if(!this.isEmpty(this.$route.query)){
    //   console.log('this.$route.query==>',this.$route.query)
    //   return
    // }
    if (!this.isEmpty(this.$route.params)) {
      this.giftCardData = this.$store.state.giftCardDetail;
      //this.getGiftCardDetails(this.$route.params.id);
      this.$store.state.user.headerBalance.show = true;
    }
  },
  mounted() {
    console.log("Gift Cards Data - ", this.giftCardData);
  }
};
</script>
<style>
.card-details {
  min-height: 250px;
  max-height: 300px;
  margin: auto 10px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 18px 18px;
  text-align: center;
  background-color: #fff;
  z-index: 99;
}
</style>
